// extracted by mini-css-extract-plugin
export default {"container":"GalleryGridBasic_container__Z7l7r","note":"GalleryGridBasic_note__ZLLOL"};